<template>
  <b-row class="text-left">
    <b-col cols="6">
      <b-form-input
        @change="$emit('change', $event)"
        @input="$emit('input-min', $event)"
        :value="minValue"
        :disabled="disabled"
        placeholder="Min"
      />
    </b-col>
    <b-col cols="6">
      <b-form-input
        placeholder="Max"
        @input="$emit('input-max', $event)"
        :value="maxValue"
        @change="$emit('change', $event)"
        :disabled="disabled"
      />
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'ConfirmationFilter',
  props: ['minValue', 'maxValue', 'disabled', 'variable'],
  computed: {
    label: function () {
      return this.variable.short_label
        ? this.variable.short_label
        : this.variable.input_label;
    },
  },
};
</script>

<style scoped></style>
